// Games/sports a mentor coaches — stored as advertising.sportsTaught (string labels),
// picked in its own top-level "Games & Sports" section in ProfileSetup + AdminMentorEdit
// (alongside Hobbies, not gated on any exam choice), shown on the mentor card/profile,
// and filterable in the directory.
// Free-form on the backend (no whitelist, same as hobbies); this list only drives the
// picker options, so adding an entry here is always safe.

export const SPORT_OPTIONS = [
  // Bat & ball
  'Cricket', 'Baseball', 'Softball',
  // Field & team
  'Football', 'Hockey', 'Rugby', 'Handball', 'Netball', 'Ultimate Frisbee',
  // Racquet
  'Badminton', 'Tennis', 'Table Tennis', 'Squash', 'Pickleball',
  // Court
  'Basketball', 'Volleyball', 'Throwball',
  // Indigenous & traditional Indian
  'Kabaddi', 'Kho-Kho', 'Mallakhamb', 'Gatka', 'Silambam', 'Roll Ball',
  // Athletics
  'Athletics (Track & Field)', 'Sprinting', 'Marathon / Long-distance Running',
  'Race Walking', 'Triathlon',
  // Combat
  'Wrestling', 'Boxing', 'Judo', 'Karate', 'Taekwondo', 'Kickboxing',
  'Mixed Martial Arts (MMA)', 'Fencing', 'Kalaripayattu', 'Self-defence',
  // Water
  'Swimming', 'Diving', 'Water Polo', 'Rowing', 'Kayaking / Canoeing', 'Sailing', 'Surfing',
  // Strength & gymnastics
  'Gymnastics', 'Weightlifting', 'Powerlifting', 'Bodybuilding', 'CrossFit',
  // Precision & target
  'Shooting', 'Archery', 'Golf', 'Snooker / Billiards', 'Bowling', 'Darts',
  // Mind sports
  'Chess', 'Carrom', 'Bridge', 'Scrabble', 'Speedcubing', 'eSports / Gaming',
  // Wheels, ice & adventure
  'Cycling', 'Skating (Roller / Inline)', 'Ice Skating', 'Skateboarding',
  'Equestrian / Horse Riding', 'Polo', 'Rock Climbing', 'Mountaineering / Trekking',
  'Paragliding',
  // NOTE: fitness & movement (Yoga, Pilates, Zumba, Aerobics, Gym) are intentionally NOT
  // here — they live in HOBBY_OPTIONS. Every label must sit in exactly one field.
  // Para sports
  'Para Athletics', 'Para Badminton', 'Wheelchair Basketball',
];
